export default __webpack_public_path__ + "static/media/Item_Wanderer's_Advice.58c62cf7.png";